import { useState, useEffect } from "react";
import axios from "axios";
import "./AliExpressOrderTracking.css";

const AliExpressOrderTracking = ({ orderId, onClose }) => {
  const [tracking, setTracking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadTracking();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId]);

  const loadTracking = async () => {
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/aliexpress/order/track/${orderId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setTracking(res.data);
      setLoading(false);
    } catch (error) {
      console.error("Erro ao carregar rastreamento:", error);
      setError(error.response?.data?.message || "Erro ao carregar rastreamento");
      setLoading(false);
    }
  };

  const getStatusIcon = (status) => {
    const icons = {
      processing: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
      ),
      confirmed: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
      ),
      shipped: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
        </svg>
      ),
      delivered: (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
          <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/>
        </svg>
      ),
    };
    return icons[status] || icons.processing;
  };

  const getStatusColor = (status) => {
    const colors = {
      processing: "#ff9800",
      confirmed: "#2196f3",
      shipped: "#9c27b0",
      delivered: "#4caf50",
      cancelled: "#f44336",
    };
    return colors[status] || "#666";
  };

  const getStatusText = (status) => {
    const texts = {
      processing: "Pedido Recebido",
      confirmed: "Pagamento Confirmado",
      shipped: "Em Trânsito",
      delivered: "Entregue",
      cancelled: "Cancelado",
    };
    return texts[status] || status;
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  if (loading) {
    return (
      <div className="tracking-modal-overlay" onClick={onClose}>
        <div className="tracking-modal" onClick={(e) => e.stopPropagation()}>
          <div className="tracking-loading">
            <div className="spinner"></div>
            <p>Carregando rastreamento...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="tracking-modal-overlay" onClick={onClose}>
        <div className="tracking-modal" onClick={(e) => e.stopPropagation()}>
          <button className="btn-close-tracking" onClick={onClose}>✕</button>
          <div className="tracking-error">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="#f44336">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
            </svg>
            <h3>Erro ao carregar rastreamento</h3>
            <p>{error}</p>
            <button className="btn-retry" onClick={loadTracking}>
              Tentar Novamente
            </button>
          </div>
        </div>
      </div>
    );
  }

  const statusOrder = ["processing", "confirmed", "shipped", "delivered"];
  const currentStatusIndex = statusOrder.indexOf(tracking.status);

  return (
    <div className="tracking-modal-overlay" onClick={onClose}>
      <div className="tracking-modal" onClick={(e) => e.stopPropagation()}>
        <button className="btn-close-tracking" onClick={onClose}>✕</button>

        <div className="tracking-header">
          <h2>Rastreamento do Pedido</h2>
          <p className="tracking-order-id">#{orderId.slice(-8)}</p>
        </div>

        {/* Current Status */}
        <div className="current-status-card" style={{ borderColor: getStatusColor(tracking.status) }}>
          <div className="status-icon" style={{ color: getStatusColor(tracking.status) }}>
            {getStatusIcon(tracking.status)}
          </div>
          <div className="status-info">
            <h3>{getStatusText(tracking.status)}</h3>
            <p>Status atual do seu pedido</p>
          </div>
        </div>

        {/* Tracking Number */}
        {tracking.trackingNumber && (
          <div className="tracking-number-card">
            <div className="tracking-label">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4z"/>
              </svg>
              Código de Rastreamento:
            </div>
            <div className="tracking-number">{tracking.trackingNumber}</div>
          </div>
        )}

        {/* Estimated Delivery */}
        {tracking.estimatedDelivery && (
          <div className="delivery-estimate">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"/>
            </svg>
            <span>
              Entrega prevista: <strong>{formatDate(tracking.estimatedDelivery)}</strong>
            </span>
          </div>
        )}

        {/* Progress Bar */}
        <div className="tracking-progress">
          {statusOrder.map((status, index) => (
            <div
              key={status}
              className={`progress-step ${index <= currentStatusIndex ? "completed" : ""} ${
                index === currentStatusIndex ? "current" : ""
              }`}
            >
              <div 
                className="progress-dot"
                style={index <= currentStatusIndex ? { backgroundColor: getStatusColor(status) } : {}}
              >
                {index < currentStatusIndex ? (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                    <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"/>
                  </svg>
                ) : null}
              </div>
              <span className="progress-label">{getStatusText(status)}</span>
              {index < statusOrder.length - 1 && (
                <div className={`progress-line ${index < currentStatusIndex ? "completed" : ""}`}></div>
              )}
            </div>
          ))}
        </div>

        {/* History */}
        {tracking.history && tracking.history.length > 0 && (
          <div className="tracking-history">
            <h3>Histórico de Movimentação</h3>
            <div className="history-timeline">
              {tracking.history.map((event, index) => (
                <div key={index} className="history-item">
                  <div 
                    className="history-dot"
                    style={{ backgroundColor: getStatusColor(event.status) }}
                  ></div>
                  <div className="history-content">
                    <div className="history-status">{getStatusText(event.status)}</div>
                    <div className="history-date">{formatDate(event.date)}</div>
                    {event.note && <div className="history-note">{event.note}</div>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Actions */}
        <div className="tracking-actions">
          <button className="btn-copy-tracking" onClick={() => {
            if (tracking.trackingNumber) {
              navigator.clipboard.writeText(tracking.trackingNumber);
              alert("Código copiado!");
            }
          }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
            </svg>
            Copiar Código
          </button>
          <button className="btn-close-modal" onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default AliExpressOrderTracking;
